<bic-popup (close)="close()" [hasBackdrop]="true" [title]="'Bild bearbeiten'" customClass="w-[421px] h-fit">
  <div bicPopupContent class="flex flex-col items-center gap-8">
    <div class="flex flex-row justify-center items-center">
      @if (isDefaultImage(image)) {
        <div class="rounded-full border border-gray-200 w-[200px] h-[200px] flex items-center justify-center bg-white">
          <fa-icon [icon]="faUser" class="text-gray-300 text-[120px]"></fa-icon>
        </div>
      }
      @if (!isDefaultImage(image)) {
        <img class="flex max-h-[340px] max-w-[340px]" id="image" [src]="image" alt="Profilbild"/>
      }
    </div>
  </div>

  <div bicPopupButtonGroup class="flex flex-row justify-between w-full gap-4">
    <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
    <bic-button [disabled]="isDefaultImage(image)" (onClick)="removeImage()">Bild entfernen</bic-button>
    <bic-button (onClick)="uploadImage()">Bild auswählen</bic-button>
  </div>
</bic-popup>
